export default "__VITE_ASSET__PUPX7M3A__"